export default __webpack_public_path__ + "static/media/Rejuvenation of the Ghagha.ad03abd9.jpg";